import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Typography,
} from '@mui/material';
import colors from '../theme/Colors';
import CustomSelect from './CustomSelect';

const EmailReportDialog = ({
  open,
  handleClose,
  selectedCustomer,
  setSelectedCustomer,
  customers,
  isLoading,
  handleSendEmail
}) => {
  return (
    <Dialog 
      open={open} 
      onClose={handleClose}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle>Email Report</DialogTitle>
      <DialogContent>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 2 }}>
          <Typography variant="body1">
            Select a customer to email this report to:
          </Typography>
          <CustomSelect
            label="Select Customer"
            value={selectedCustomer}
            onChange={(e) => setSelectedCustomer(e.target.value)}
            options={customers?.map((c) => ({ id: c._id, name: c.name }))}
            sx={{ minWidth: 250 }}
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>
          Cancel
        </Button>
        <Button
          onClick={handleSendEmail}
          variant="contained"
          disabled={!selectedCustomer || isLoading}
          sx={{
            backgroundColor: colors.primary,
            color: 'black',
            '&:hover': {
              backgroundColor: colors.primary,
              opacity: 0.9
            }
          }}
        >
          {isLoading ? 'Sending...' : 'Send Email'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EmailReportDialog;
